var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"nav-list overflow-y-auto",attrs:{"dense":""}},[_vm._t("default"),_vm._l((_vm.clubs),function(club){return _c('nav-list-item',{key:club._id,attrs:{"id":`club-${club.id}`,"item":club,"active":club.id === +_vm.clubId,"mode":"child","activator":""},on:{"click":function($event){return _vm.$emit('click', club)}}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }